(function () {
  function initOtoZenArticleToc() {
    const article = document.querySelector('.art-pg.otozen-article-template');

    if (!article || article.dataset.tocReady === 'true') {
      return;
    }

    const articleBody = article.querySelector('.art-pg__body');

    if (!articleBody) {
      return;
    }

    /*
    * Responsive article tables
    *
    * Copies each desktop table header into the matching
    * mobile table cell as a data-label.
    */
    const articleTables = articleBody.querySelectorAll('table');

    articleTables.forEach(function (table) {
    const headers = Array.from(
        table.querySelectorAll('thead th')
    ).map(function (header) {
        return header.textContent.trim();
    });

    if (!headers.length) {
        return;
    }

    const rows = table.querySelectorAll('tbody tr');

    rows.forEach(function (row) {
        const cells = row.querySelectorAll('td');

        cells.forEach(function (cell, index) {
        if (headers[index]) {
            cell.setAttribute('data-label', headers[index]);
        }
        });
    });
    });
    
    /*
     * Quick Answer
     * Preserve existing ID if Liquid already provides one.
     */
    const quickAnswerHeading = article.querySelector('.otozen-quick-answer h2');

    if (quickAnswerHeading && !quickAnswerHeading.id) {
      quickAnswerHeading.id = 'quick-answer';
    }

    /*
     * Get article headings.
     *
     * Include:
     * - H2 main sections
     * - H3 subsections
     *
     * Exclude:
     * - CTA heading
     * - individual FAQ questions
     *
     * FAQ main H2 ("Frequently Asked Questions") remains included.
     */
    const headings = Array.from(
      articleBody.querySelectorAll('h2, h3')
    ).filter(function (heading) {
      if (!heading.textContent.trim()) {
        return false;
      }

      if (heading.closest('.cta-banner')) {
        return false;
      }

      if (heading.closest('.faq-item')) {
        return false;
      }

      return true;
    });

    if (!headings.length) {
      return;
    }

    /*
     * Track existing IDs so duplicate anchors are never created.
     */
    const usedIds = new Set(
      Array.from(document.querySelectorAll('[id]'))
        .map(function (element) {
          return element.id;
        })
        .filter(Boolean)
    );

    /*
     * Turn heading text into a clean URL fragment.
     *
     * Example:
     * "How Family Location Sharing Works"
     * becomes:
     * #how-family-location-sharing-works
     *
     * Leading numbering such as "1. OtoZen" becomes #otozen,
     * which keeps the anchor cleaner if section order changes later.
     */
    function slugifyHeading(text) {
      const cleanText = text
        .trim()
        .replace(/^\d+[\.\)]\s*/, '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/['’]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .replace(/-+/g, '-');

      return cleanText || 'section';
    }

    function ensureHeadingId(heading) {
      /*
       * Never overwrite an ID already added manually
       * or supplied by future blog HTML.
       */
      if (heading.id) {
        usedIds.add(heading.id);
        return heading.id;
      }

      const baseId = slugifyHeading(heading.textContent);
      let finalId = baseId;
      let number = 2;

      while (
        usedIds.has(finalId) ||
        document.getElementById(finalId)
      ) {
        finalId = baseId + '-' + number;
        number += 1;
      }

      heading.id = finalId;
      usedIds.add(finalId);

      return finalId;
    }

    headings.forEach(ensureHeadingId);

    /*
     * Create "On this page" navigation.
     */
    const toc = document.createElement('nav');
    toc.className = 'otozen-article-toc';
    toc.setAttribute('aria-labelledby', 'otozen-article-toc-title');

    const tocTitle = document.createElement('p');
    tocTitle.className = 'otozen-article-toc__title';
    tocTitle.id = 'otozen-article-toc-title';
    tocTitle.textContent = 'On this page';

    const tocList = document.createElement('ul');
    tocList.className = 'otozen-article-toc__list';

    /*
     * Quick Answer appears first when available.
     */
    if (quickAnswerHeading && quickAnswerHeading.id) {
      const quickAnswerItem = document.createElement('li');
      quickAnswerItem.className = 'otozen-article-toc__item';

      const quickAnswerLink = document.createElement('a');
      quickAnswerLink.href = '#' + quickAnswerHeading.id;
      quickAnswerLink.textContent = 'Quick Answer';

      quickAnswerItem.appendChild(quickAnswerLink);
      tocList.appendChild(quickAnswerItem);
    }

    let currentH2Item = null;
    let currentSubList = null;

    headings.forEach(function (heading) {
      const link = document.createElement('a');

      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();

      const listItem = document.createElement('li');

      if (heading.tagName === 'H2') {
        listItem.className = 'otozen-article-toc__item';
        listItem.appendChild(link);

        tocList.appendChild(listItem);

        currentH2Item = listItem;
        currentSubList = null;

        return;
      }

      /*
       * H3 becomes nested underneath its nearest previous H2.
       */
      listItem.className =
        'otozen-article-toc__item otozen-article-toc__item--sub';

      listItem.appendChild(link);

      if (currentH2Item) {
        if (!currentSubList) {
          currentSubList = document.createElement('ul');
          currentSubList.className = 'otozen-article-toc__sublist';
          currentH2Item.appendChild(currentSubList);
        }

        currentSubList.appendChild(listItem);
      } else {
        tocList.appendChild(listItem);
      }
    });

    toc.appendChild(tocTitle);
    toc.appendChild(tocList);

    /*
     * Place TOC immediately before the article body.
     *
     * Result:
     * Featured Image
     * Quick Answer
     * On this page
     * Article content
     * Create desktop article layout:
     *
     * Left:
     * - Quick Answer
     * - Article content
     *
     * Right:
     * - Sticky "On this page"
    */
    const articleHeader = article.querySelector('.art-pg__header');
    const quickAnswer = article.querySelector('.otozen-quick-answer');

    const layout = document.createElement('div');
    layout.className = 'otozen-article-layout';

    const mainContent = document.createElement('div');
    mainContent.className = 'otozen-article-main';

    /*
    * Keep breadcrumb full width.
    *
    * Desktop layout begins from article title:
    *
    * Left:
    * Title
    * Meta
    * Featured Image
    * Quick Answer
    * Article Content
    *
    * Right:
    * On this page
    */
    articleHeader.parentNode.insertBefore(layout, articleHeader);

    layout.appendChild(mainContent);

    mainContent.appendChild(articleHeader);

    if (quickAnswer) {
    mainContent.appendChild(quickAnswer);
    }

    mainContent.appendChild(articleBody);

    layout.appendChild(toc);

    article.dataset.tocReady = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initOtoZenArticleToc
    );
  } else {
    initOtoZenArticleToc();
  }

  /*
   * Keeps it working inside Shopify Theme Editor too.
   */
  document.addEventListener(
    'shopify:section:load',
    initOtoZenArticleToc
  );
})();